import React from "react";
import { cn } from "./cn";

// Bloco de carregamento — o tamanho vem de fora (className="h-4 w-32").
export const Skeleton: React.FC<{ className?: string }> = ({ className }) => (
  <div aria-hidden className={cn("animate-pulse rounded-control bg-surface-hover", className)} />
);

/** Linhas no formato dos itens de uma lista que ainda está carregando; `label` é lido pelo leitor de tela. */
export const SkeletonRows: React.FC<{ label: string; rows?: number }> = ({ label, rows = 2 }) => (
  <div role="status" className="flex flex-col gap-2.5">
    <span className="sr-only">{label}</span>
    {Array.from({ length: rows }, (_, i) => (
      <Skeleton key={i} className="h-14 w-full rounded-card" />
    ))}
  </div>
);
